import { Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarClickEvent, CalendarTask } from '@infodata-group/inf-commons';

@Component({
  selector: 'infl-task',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './task.component.html',
  styleUrl: './task.component.scss',
})
export class TaskComponent {
  public task = input.required<CalendarTask>();
  public canResize = input(true);

  public startResize = output<{
    event: MouseEvent;
    task: CalendarTask;
    direction: 'left' | 'right';
  }>();
  public taskClick = output<CalendarClickEvent>();
  public taskDblClick = output<CalendarClickEvent>();
  public taskHover = output<CalendarTask>();

  public taskStyle = computed(() => {
    return {
      borderColor: this.task().borderColor ?? this.task().backgroundColor,
      color: this.task().color,
    };
  });

  resize(event: MouseEvent, task: CalendarTask, direction: 'left' | 'right') {
    if (this.canResize()) {
      event.stopPropagation();
      event.stopImmediatePropagation();
      event.preventDefault();
      this.startResize.emit({ event: event, task: task, direction: direction });
    }
  }

  onTaskClick(event: MouseEvent, task: CalendarTask, dblClick: boolean) {
    const calendarEvent = new CalendarClickEvent(event, task);
    dblClick
      ? this.taskDblClick.emit(calendarEvent)
      : this.taskClick.emit(calendarEvent);
  }
}
